module.exports = __webpack_public_path__ + "b8a70b88bf06747294f8e24a4fc3c299.png";